module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section1",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('p', {
    staticClass: "xxlarge"
  }, [_vm._v("\nMY FOUR WEEKS"), _c('br', {
    staticClass: "calibre5"
  }), _vm._v("\nIN FRANCE")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('i', {
    staticClass: "calibre6"
  }, [_vm._v("By")]), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "large"
  }, [_vm._v("RING W. LARDNER")]), _c('br', {
    staticClass: "calibre7"
  })]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', {
    staticClass: "xsmall"
  }, [_vm._v("ILLUSTRATED BY")]), _c('br', {
    staticClass: "calibre7"
  }), _vm._v(" "), _c('span', {
    staticClass: "large"
  }, [_vm._v("WALLACE MORGAN")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15f8d122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section004.vue
// module id = 63
// module chunks = 0